export default __webpack_public_path__ + "static/media/shiningStar.ddc3284d.jpeg";